import React, { Fragment, useState } from 'react';
import { Transition, Dialog } from '@headlessui/react';
import clsx from 'clsx';

import SidebarContent from './SidebarContent';
import { useAtom } from 'jotai';
import { mobileSidebar } from '../../jotaiStore';
import { User } from '@supabase/supabase-js';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useHydrateAtoms } from 'jotai/utils';

const scrollbarStyle =
  'scrollbar scrollbar-thumb-shades-surfaceDark scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-track-shades-base scrollbar-w-2';

const MobileSidebarContainer: React.FC<{
  user: User | null;
  setShowLoadingContent: (showLoadingContent: boolean) => void;
  graphID: string;
  children: React.ReactNode;
}> = ({ user, setShowLoadingContent, graphID, children }) => {
  useHydrateAtoms([[mobileSidebar, false]]);
  const [showMobileSidebar, setShowMobileSidebar] = useAtom(mobileSidebar);

  return (
    <div className="w-full">
      <Transition.Root show={showMobileSidebar} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 min-[1100px]:hidden"
          onClose={setShowMobileSidebar}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-900/80 " />
          </Transition.Child>

          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-12 @mobile/sidebar:mr-16 flex w-full max-w-[600px] flex-1">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute left-full top-0 flex w-12 @mobile/sidebar:w-16 justify-center pt-5">
                    <button
                      type="button"
                      className="-m-2.5 p-2.5"
                      onClick={() => setShowMobileSidebar(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div
                  className={clsx(
                    'flex grow flex-col gap-y-5 overflow-y-auto  h-full bg-shades-base overflow-x-hidden',
                    scrollbarStyle
                  )}
                >
                  <SidebarContent
                    user={user}
                    setShowLoadingContent={setShowLoadingContent}
                    graphID={'mobile-sidebar-graph'}
                  >
                    {children}
                  </SidebarContent>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default MobileSidebarContainer;
